import styled from 'styled-components';


const VehicleInfoWrapper = styled.div`
.vehicle-wrapperar .p-accordion .p-accordion-header .p-accordion-header-link .p-accordion-toggle-icon {
 
    left: 0;
    right: auto;
    
}

.vehicle-wrapperar .extra-vehicle.{
    padding: 8px 24px 10px 10px;
}

p {
    font-size: 18px;
    font-weight: bold;
    color: #4c565c;
}

.vehicle-info-wrapper {
    margin-top: 23px;
}

.text-wrapper {
    p {
        font-size: 24px;
        font-weight: 800;
    }
}

.head-wrapper {
    margin-left: 15px;
}

.bottom-wrapper {
    margin-left: 15px;
}

.head-wrapper p {
    flex-grow: 0;

    font-size: 20px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1;
    letter-spacing: normal;
    text-align: initial;
    margin-left: 21px;
    color: #6B47F5;
}

.bottom-wrapper p {
    flex-grow: 0;
    font-size: 16px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.04;
    letter-spacing: normal;
    text-align: initial;
    color: #4c565c;
    margin-left: 21px;
}

.accord-img {
    text-align: initial;
    float: left;
    margin-left: 10px;
    height: 60px;
}

.vehicle-image {
    text-align: initial;
    float: left;
    margin-left: 10px;

    img {
        height: 36px;
    }
}

.tile {
    width: 25%;
    border-left: 1px solid #edf2f5;
    display: inline-block;
}

.tileFirst {
    width: 25%;
    display: inline-block;
    float: left;
}

.vehicle-dropdown h4 {
    flex-grow: 0;
    font-size: 13px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1;
    padding: 11px 0px 0px 20px;
    letter-spacing: normal;
    text-align: initial;
    color: #818b9b;
}

.vehicle-dropdown p {
    flex-grow: 0;
    padding: 11px 0px 0px 20px;
    font-size: 13px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: initial;
    color: #6B47F5;
}

.vel-wrapper-mobile {
    display: none;
}

.p-accordion .p-accordion-header .p-accordion-header-link {
    border: 1px solid #dee2e6;
    color: #6c757d;
    background: #fff;
    font-weight: 700;
    border-radius: 6px;
    -webkit-transition: box-shadow 0.2s;
    transition: box-shadow 0.2s;
}

.p-accordion .p-accordion-header:not(.p-disabled) .p-accordion-header-link:focus {
    outline: 0 none;
    outline-offset: 0;
    box-shadow: none;
}

.hjiika .p-accordion .p-accordion-header .p-accordion-header-link {
    border: 1px solid #dee2e6;
    color: #6c757d;
    background: #fff;
    font-weight: 700;
    border-radius: 6px;
    -webkit-transition: box-shadow 0.2s;
    transition: box-shadow 0.2s;
}

.p-accordion .p-accordion-header:not(.p-highlight):not(.p-disabled):hover .p-accordion-header-link {
    background: #fff;
    border-color: #dee2e6;
    color: #343a40;
}

.p-accordion .p-accordion-header:not(.p-disabled).p-highlight .p-accordion-header-link {
    background: #fff;
    border-color: #dee2e6;
    color: #343a40;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
}

.p-accordion .p-accordion-header .p-accordion-header-link {
    border: 1px solid #dee2e6;
    color: #6c757d;
    background: #fff;
    font-weight: 700;
    border-radius: 6px;
    transition: box-shadow 0.2s;
}

.p-accordion .p-accordion-header .p-accordion-header-link .p-accordion-toggle-icon {
    position: absolute;
    color: #6B47F5;
    right: 0px;
    width: 45px;
    height: 45px;
    top: 0px;
    -webkit-box-flex: 0;
    -webkit-box-flex: 0;
    -webkit-flex-grow: 0;
    -ms-flex-positive: 0;
    flex-grow: 0;
    margin: 23px 25px 29px 20px;
    padding: 15px 0px 0px 0px;
    border-radius: 27px;
    background-color: #edf2f5;
}

@media only screen and (max-width: 576px) {
    .vehicle-wrapperar .accord-img {
        text-align: initial;
        float: left;
        margin-left: 0px;
        height: 36px;
        margin-right: 63px;
    }
    .accord-class{
        padding: 12px 18px;
    }
    .accord-text{
        padding: 1px 0px;
    }
    .extra-vehicle{
        padding: 8px 24px 10px 10px;
    }
    .vehicle-wrapperar .extra-vehicle.{
        padding: 8px 24px 10px 10px;
    }
    .p-accordion .p-accordion-header:not(.p-disabled) .p-accordion-header-link:focus {
        outline: 0 none;
        outline-offset: 0;
        box-shadow: none;
    }

    .p-accordion .p-accordion-header:not(.p-disabled).p-highlight .p-accordion-header-link {
        background: #fff;
        border-color: #fff;
        color: #343a40;
        border-bottom-right-radius: 0;
        border-bottom-left-radius: 0;
    }

    .p-accordion .p-accordion-header:not(.p-highlight):not(.p-disabled):hover .p-accordion-header-link {
        background: #fff;
        border-color: #fff;
        color: #343a40;
    }

    .p-accordion .p-accordion-tab {
        margin-bottom: 4px;
        box-shadow: 0 10px 15px 0 rgb(0 0 0 / 5%);
        border: solid 1px #edf2f5;
        background-color: #fff;
    }

    .p-accordion .p-accordion-header .p-accordion-header-link {
        padding: 0px 0px 0px 9px;
        border: 1px solid #dee2e6;
        color: #6c757d;
        background: #fff;
        font-weight: 700;
        border-radius: 6px;
        transition: box-shadow 0.2s;
    }

    .p-accordion .p-accordion-header:not(.p-highlight):not(.p-disabled):hover .p-accordion-header-link {
        background: #e9ecef;
        border-color: #dee2e6;
        color: #343a40;
    }

    .p-accordion .p-accordion-header .p-accordion-header-link .p-accordion-toggle-icon {
        position: absolute;

        color: #6B47F5;
        right: 0px;
        width: 32px;
        height: 32px;
        top: 0px;
        -webkit-box-flex: 0;
        flex-grow: 0;
        margin: 27px 25px 29px 20px;
        padding: 7px;
        border-radius: 19px;
        background-color: #edf2f5;
    }

    .colm {
        border-bottom: 2px solid #edf2f5;
        text-align: initial;
    }

    .vehicle-info-wrapper {
        display: none;
    }

    .head-wrapper p {
        margin-top: 8px;
        margin-bottom: 7px;
        flex-grow: 0;
        font-size: 15px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1;
        letter-spacing: normal;
        text-align: initial;
        color: #6B47F5;
    }

    .bottom-wrapper p {
        flex-grow: 0;

        font-size: 13px;
        font-weight: 600;
        font-stretch: normal;
        font-style: normal;
        line-height: 1;
        letter-spacing: normal;
        text-align: initial;
        color: #4c565c;
    }

    .vel-wrapper-mobile {
        display: block;
    }

    .policy-wrapper {
        display: none;
    }

    .pie-info-chart {
        position: absolute;
        margin: -7px 26px;
    }

    .policycard {
        font-size: 15px;
        text-align: initial;

        img {
            height: 15px;
        }

        p {
            font-size: 7px;
            color: #818b9b;
        }

        h4 {
            font-size: 7px;
            color: #6B47F5;
        }
    }

    .pol-wrapper-mobile {
        display: block;
    }

    .flex-container {
        display: flex;
        flex-direction: row;
        font-size: 15px;
        text-align: center;
    }

    .accord-img {
        text-align: initial;
        float: left;
        margin-left: 10px;
        height: 60px;
    }

    .p-message-wrapper {
        p {
            font-size: 15px;
            font-weight: bold;
            color: #4c565c;
        }

        span {
            font-size: 15px;
            font-weight: bold;
            color: red;
        }
    }

    .calm {
        border-bottom: 2px solid #edf2f5;
        text-align: initial;
    }

 
    .col-2 {
        padding: 12px 21px;
    }
}

@media only screen and (max-width: 768px) {
    
    .accord-class{
        padding: 12px 18px;
    }
    .accord-text{
        padding: 1px 0px;
    }
    .extra-vehicle{
        padding: 8px 24px 10px 10px;
    }
    .vehicle-wrapperar .extra-vehicle.{
        padding: 8px 24px 10px 10px;
    }
    .vehicle-wrapperar .accord-text {
        padding: 0px 14px;
    }
    .vehicle-wrapperar .accord-img {
        text-align: initial;
        float: left;
        margin-left: 0px;
        height: 36px;
        margin-right: 63px;
    }
    .p-accordion .p-accordion-header:not(.p-disabled) .p-accordion-header-link:focus {
        outline: 0 none;
        outline-offset: 0;
        box-shadow: none;
    }

    .p-accordion .p-accordion-header:not(.p-disabled).p-highlight .p-accordion-header-link {
        background: #fff;
        border-color: #fff;
        color: #343a40;
        border-bottom-right-radius: 0;
        border-bottom-left-radius: 0;
    }

    .p-accordion .p-accordion-header:not(.p-highlight):not(.p-disabled):hover .p-accordion-header-link {
        background: #fff;
        border-color: #fff;
        color: #343a40;
    }

    .p-accordion .p-accordion-tab {
        margin-bottom: 4px;
        box-shadow: 0 10px 15px 0 rgb(0 0 0 / 5%);
        border: solid 1px #edf2f5;
        background-color: #fff;
    }

    .col-2 {
        padding: 12px 21px;
    }

    .p-accordion .p-accordion-header .p-accordion-header-link {
        padding: 0px 0px 0px 9px;
        border: 1px solid #dee2e6;
        color: #6c757d;
        background: #fff;
        font-weight: 700;
        border-radius: 6px;
        transition: box-shadow 0.2s;
    }

    .p-accordion .p-accordion-header .p-accordion-header-link .p-accordion-toggle-icon {
        position: absolute;

        color: #6B47F5;
        right: 0px;
        width: 29px;
        height: 29px;
        top: 0px;
        -webkit-box-flex: 0;
        flex-grow: 0;
        margin: 12px 18px 29px 20px;
        padding: 7px;
        border-radius: 19px;
        background-color: #edf2f5;
    }

    .col-2 {
        padding: 9px 21px;
    }


    .colm {
        border-bottom: 2px solid #edf2f5;
        text-align: initial;
    }

    .vehicle-info-wrapper {
        display: none;
    }

    .accord-img {
        text-align: initial;
        float: left;
        margin-left: 0px;
        height: 36px;
    }

    .vel-wrapper-mobile {
        display: block;
    }
}

.policy-wrapper {
    display: none;
}

.pie-info-chart {
    position: absolute;
    margin: -7px 26px;
}

.policycard {
    font-size: 15px;
    text-align: initial;

    img {
        height: 15px;
    }

    p {
        font-size: 7px;
        color: #818b9b;
    }

    h4 {
        font-size: 7px;
        color: #6B47F5;
    }
}

.pol-wrapper-mobile {
    display: block;
}

.row-view{
 display: flex;
    flex-direction: row;
         align-items:flex-start;
        border:2px soild black;
}

.flex-container {
    display: flex;
    flex-direction: row;
    font-size: 15px;
    text-align: center;
}

.p-message-wrapper {
    p {
        font-size: 15px;
        font-weight: bold;
        color: #4c565c;
    }

    span {
        font-size: 15px;
        font-weight: bold;
        color: red;
    }
}

.vehicle-style {
    padding: 10px 10px 10px 10px;

    h4 {
        font-size: 13px;
        color: var(--steel);
        font-weight: bold;
    }

    p {
        color: #6B47F5;
        font-size: 13px;
        font-weight: bold;
    }
    
}

.ar{
    .head-wrapper p {
        margin-left: 0;
        text-align: right;
        margin-right: 15px;
    }
    .bottom-wrapper p{
        text-align: right;
        margin-right: 21px;
        margin-left: 0;
    }
    .p-accordion .p-accordion-header .p-accordion-header-link .p-accordion-toggle-icon {
        left: 0;
        right: auto;
    }
    .vehicle-image {
        text-align: initial;
        float: ;
        margin-left: 0;
        margin-right: 10px;
    }
    .vehicle-dropdown h4,.vehicle-dropdown p{
        text-align: initial;
        padding: 11px 20px 0px 0;
    }
}
`;
export default VehicleInfoWrapper;
